import { Button } from "@/components/ui/button";
import { ErrorText } from "@/components/ui/error";
import { Spinner } from "@/components/ui/spinner";
import { loginPath } from "@/constants";
import { shopifyConnect } from "@/hooks/shopify-mutation";
import { useAuth } from "@/providers/auth";
import { useOrg } from "@/providers/organization";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/auth/shopify/connect")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { getToken } = useAuth();
  const { storeOrg, orgId } = useOrg();
  const [err, setErr] = useState("");
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    // Get URL parameters from current location
    const urlParams = new URLSearchParams(window.location.search);
    const shop = urlParams.get("shop");
    const hmac = urlParams.get("hmac");
    const state = urlParams.get("state");
    const code = urlParams.get("code");
    const timestamp = urlParams.get("timestamp");

    // Validate required parameters
    if (!shop || !hmac || !state || !code || !timestamp) {
      console.error("Missing required Shopify connect parameters");
      setErr(t("auth.shopifyConnect.missingParams"));
      return;
    }

    // Call the async function, it redirects to the dashboard on success
    shopifyConnect(urlParams.toString(), getToken, orgId, storeOrg, setErr);
  }, [storeOrg]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        {err !== "" ? (
          <div className="flex flex-col items-center gap-4">
            <ErrorText className="w-full">{err}</ErrorText>
            <Button asChild variant="outline" className="rounded-sm">
              <Link to={loginPath}>{t("auth.backToLogin")}</Link>
            </Button>
          </div>
        ) : (
          <div className="flex flex-col items-center space-y-4">
            <Spinner className="size-8" />
            <p>{t("auth.shopifyConnect.loggingIn")}</p>
          </div>
        )}
      </div>
    </div>
  );
}
